<template>
  <section class="tile is-child box p-none p-b-md" v-if="currentOffer && school">


    <div class="card-image">
      <figure class="image is-3by1 m-b-none">
        <img :src="randomImage(offer)" alt="">
      </figure>
      <div class="is-overlay is-clipped">
        <nav class="breadcrumb is-medium is-primary-opacity p-t-sm " aria-label="breadcrumbs">
          <ul class="p-l-md">
            <li v-if="$route.matched[0].meta.schoolType !== 'eschool'">
              <router-link :to="{ name: 'highschool-categories'}">
                {{ $t('shop.offers.list') }}
              </router-link>
            </li>
            <li v-else>
              <router-link :to="{ name: 'eshop-categories'}">
                {{ $t('shop.offers.list') }}
              </router-link>
            </li>
            <li v-if="$route.matched[0].meta.schoolType !== 'eschool'">
              <router-link :to="{ name: 'highschool-category', params: { categoryId: currentOffer.categoryId }}">
                {{ currentOffer.category.name.fr }}
              </router-link>
            </li>
            <li v-else>
              <router-link :to="{ name: 'eshop-category', params: { categoryId: currentOffer.categoryId }}">
                {{ currentOffer.category.name.fr }}
              </router-link>
            </li>
            <li class="is-active "><a
                class="is-italic has-text-weight-light has-text-white title is-4">{{ currentOffer.name.fr }}</a></li>
          </ul>
          <hr>
        </nav>
      </div>
    </div>


    <section class="section p-t-sm">

      <div class="columns selected-session m-t-md" v-if="selectedSession">

        <div class="column is-one-quarter-desktop selected-session-image">
          <figure class="image is-3by2 m-b-none">
            <img :src="'/img/campus/'+selectedSession.campus.image" alt="">
          </figure>
        </div>
        <div class="column is-5 session-text">
          <div class="heading-line title has-text-weight-light">
                        <span>
                            {{ selectedSession.offer.name.fr }}
                        </span>

          </div>
          <div class="subtitle is-5 is-italic">{{ selectedSession.campus.name }}</div>
        </div>
        <div
            class="column session-price has-text-white has-text-centered has-vertically-aligned-content has-background-primary">

          <div>
            <i class="is-size-4 has-text-weight-light">{{ selectedSession.begin | moment }} -
              {{ selectedSession.end | moment }}</i>
          </div>
          <hr>
          <div class="m-t-md">

            <div class="columns">
              <div class="column">
                <div v-if="school && school.type === 'boardingschool'">
                  <i>{{ $t('candidate.choices.boardingschool.internship') }}</i></div>
                <span class="is-size-4" v-if="selectedSession.prices.length">{{
                    offerFees(selectedSession.prices)
                  }}</span>
                <span class="is-size-4" v-else>{{ offerFees(currentOffer.prices) }}</span>
                <div class="columns has-text-centered is-multiline m-t-sm">
                  <div class="column" v-for="candidate in candidates"
                       v-if="candidate.applications && candidate.applications.choices">
                    <button class="button has-background-white-ter"
                            v-if="isSelectedCandidate({candidate, session:selectedSession.id})"
                            disabled>
                      {{ $t('shop.offers.register') }}
                    </button>
                    <button class="button has-background-primary has-text-light"
                            @click="addSessionChoiceToCart({candidate, offer, school, session:selectedSession, type:'internat'})"
                            v-else>
                      {{ $t('shop.offers.register') }}
                    </button>

                  </div>
                  <div class="column" v-if="!isLoggedIn || !hasCandidates">
                    <button class="button has-background-white-ter"
                            v-if="isSelectedGuestSessionChoice({candidate:null, offer, session:selectedSession})"
                            disabled>
                      {{ $t('shop.offers.book') }}
                    </button>
                    <button class="button has-background-primary has-text-light"
                            @click="guestChoice({candidate:null, offer, school, session:selectedSession, type:'internat'})"
                            v-else>
                      {{ $t('shop.offers.book') }}
                    </button>

                  </div>
                </div>

              </div>
              <div class="column border-left"
                   v-if="externshipFees(selectedSession.prices) || externshipFees(currentOffer.prices)">
                <div v-if="school && school.type === 'boardingschool'">
                  <i>{{ $t('candidate.choices.boardingschool.externship') }}</i></div>
                <span class="is-size-4" v-if="externshipFees(selectedSession.prices)">{{
                    offerExternshipFees(selectedSession.prices)
                  }}</span>
                <span class="is-size-4" v-else>{{ offerExternshipFees(currentOffer.prices) }}</span>
                <div class="columns has-text-centered is-multiline m-t-sm">
                  <div class="column" v-for="candidate in candidates"
                       v-if="candidate.applications && candidate.applications.choices">
                    <button class="button has-background-white-ter"
                            v-if="isSelectedCandidate({candidate, session:selectedSession.id})"
                            disabled>
                      {{ $t('shop.offers.register') }}
                    </button>
                    <button class="button has-background-primary has-text-light"
                            @click="addSessionChoiceToCart({candidate, offer, school, session:selectedSession, type:'externat'})"
                            v-else>
                      {{ $t('shop.offers.register') }}
                    </button>

                  </div>
                  <div class="column" v-if="!isLoggedIn || !hasCandidates">
                    <button class="button has-background-white-ter"
                            v-if="isSelectedGuestSessionChoice({candidate:null, offer, session:selectedSession})"
                            disabled>
                      {{ $t('shop.offers.book') }}
                    </button>
                    <button class="button has-background-primary has-text-light"
                            @click="guestChoice({candidate:null, offer, school, session:selectedSession, type:'externat'})"
                            v-else>
                      {{ $t('shop.offers.book') }}
                    </button>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="p-md">
        <h3 class="title is-4 heading-line title has-text-weight-light"><strong>{{
            $t('shop.offers.description')
          }}</strong></h3>

        <p class="ql-editor" v-html="currentOffer.description.fr"></p>
      </div>

      <div class="p-md" v-if="currentOffer.advantages.fr">
        <h3 class="title is-4 heading-line title has-text-weight-light"><strong>{{
            $t('shop.offers.advantages')
          }}</strong></h3>

        <p class="ql-editor" v-html="currentOffer.advantages.fr"></p>
      </div>

      <div class="p-md" v-if="currentOffer.condition.fr">
        <h3 class="title is-4 heading-line title has-text-weight-light"><strong>{{
            $t('shop.offers.conditions')
          }}</strong></h3>

        <p class="ql-editor" v-html="currentOffer.condition.fr"></p>
      </div>


      <div class="p-md" v-if="!currentOffer.category.has_sessions">
        <h3 class="title is-4 heading-line title has-text-weight-light"><strong>{{ $t('shop.offers.price') }}</strong>
        </h3>
        <p><span class="is-size-4">{{ offerFees(currentOffer.prices) }}</span></p>
      </div>

      <div v-if="currentOffer.category.has_sessions">

        <div class="p-md m-b-md sessions has-background-primary ">
          <h3 class="title is-4 heading-line title has-text-weight-light">
            <strong class="has-text-white">{{ $t('shop.offers.session_choice') }}</strong></h3>
        </div>

        <div>
          <transition name="component-fade" mode="out-in">
            <component
                :is="filtersView"
                :offerFilter="false"
                @filter="filterSessions">
            </component>
          </transition>
        </div>


        <transition name="slide-fade">
          <div class="columns is-multiline">
            <div class="column is-6" v-for="(session, index) in offerSessions">

              <div class="card-image offer-session">

                <figure class="image is-3by1 m-b-none session-image">
                  <img :src="'/img/campus/'+session.campus.image" alt="">
                </figure>
                <div class="is-overlay is-clipped ">
                  <div
                      class="subtitle is-4 is-italic is-primary-opacity has-text-white has-text-centered p-t-sm p-b-sm has-text-weight-light">
                    {{ session.campus.name }}
                  </div>
                </div>

                <div class="session-price p-t-md has-text-centered">
                  <div>
                    <i class="is-size-4 has-text-weight-bold">{{ session.begin | moment }} - {{
                        session.end | moment
                      }}</i>
                  </div>
                  <hr>
                  <div class="m-t-md">

                    <div class="columns">
                      <div class="column p-md">
                        <div v-if="school && school.type === 'boardingschool'">
                          <i>{{ $t('candidate.choices.boardingschool.internship') }}</i>
                        </div>
                        <span class="is-size-4 " v-if="session.prices.length">{{ offerFees(session.prices) }}</span>
                        <span class="is-size-4" v-else>{{ offerFees(currentOffer.prices) }}</span>
                        <span class="is-size-5"
                              v-if="session.remaining_places !== null && session.remaining_places > 0">
                          <br>
                          <span
                              :class="session.remaining_places < 5 ? 'has-text-danger':'has-text-success'">
                            {{
                              session.remaining_places > 1 ? session.remaining_places + ' places disponibles' : session.remaining_places + ' place disponible'
                            }}
                          </span>
                        </span>
                        <div class="columns has-text-centered is-multiline m-t-sm">
                          <div class="column" v-if="session.status">
                            <div class="stamp " :class="session.status === 'complete' ? 'is-nope':'is-draft'">
                              {{ displayStatus(session.status) }}
                            </div>
                          </div>

                          <div class="column" v-else>
                            <div v-for="candidate in candidates"
                                 v-if="candidate.applications && candidate.applications.choices">
                              <button class="button has-background-white-ter"
                                      v-if="cantRegister(candidate, session)"
                                      disabled>
                                {{ $t('shop.offers.register') }}
                              </button>
                              <button class="button has-background-primary has-text-light"
                                      @click="addSessionChoiceToCart({candidate, offer, school, session, type:'internat'})"
                                      v-else>
                                {{ $t('shop.offers.register') }}
                              </button>

                            </div>
                            <div class="column" v-if="!isLoggedIn || !hasCandidates">
                              <button class="button has-background-white-ter"
                                      v-if="cantGuestRegister(offer, session)"
                                      disabled>
                                {{ $t('shop.offers.book') }}
                              </button>
                              <button class="button has-background-primary has-text-light"
                                      @click="guestChoice({candidate:null, offer, school, session, type:'internat'})"
                                      v-else>
                                {{ $t('shop.offers.book') }}
                              </button>

                            </div>
                          </div>


                        </div>

                      </div>

                      <div class="column p-md border-left"
                           v-if="externshipFees(session.prices) || externshipFees(currentOffer.prices)">
                        <div v-if="school && school.type === 'boardingschool'">
                          <i>{{ $t('candidate.choices.boardingschool.externship') }}</i></div>
                        <span class="is-size-4"
                              v-if="externshipFees(session.prices)">{{ offerExternshipFees(session.prices) }}</span>
                        <span class="is-size-4" v-else>{{ offerExternshipFees(currentOffer.prices) }}</span>
                        <div class="columns has-text-centered is-multiline m-t-sm">

                          <div class="column" v-for="candidate in candidates"
                               v-if="candidate.applications && candidate.applications.choices">
                            <button class="button has-background-white-ter"
                                    v-if="isSelectedCandidate({candidate, session:session.id})"
                                    disabled>
                              {{ $t('shop.offers.register') }}
                            </button>
                            <button class="button has-background-primary has-text-light"
                                    @click="addSessionChoiceToCart({candidate, offer, school, session, type:'externat'})"
                                    v-else>
                              {{ $t('shop.offers.register') }}
                            </button>

                          </div>
                          <div class="column" v-if="!isLoggedIn || !hasCandidates">
                            <button class="button has-background-white-ter"
                                    v-if="isSelectedGuestSessionChoice({candidate:null, offer, session})"
                                    disabled>
                              {{ $t('shop.offers.book') }}
                            </button>
                            <button class="button has-background-primary has-text-light"
                                    @click="guestChoice({candidate:null, offer, school, session, type:'externat'})"
                                    v-else>
                              {{ $t('shop.offers.book') }}
                            </button>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>

    </section>

    <div class="columns has-text-centered" v-if="!currentOffer.category.has_sessions">
      <hr>
      <div class="column" v-for="candidate in candidates"
           v-if="candidate.applications && candidate.applications.choices">
        <button class="button has-background-white-ter"
                v-if="isSelectedChoice({candidate, offer}) || !acceptedCandidate(candidate)"
                disabled>
          {{ $t('shop.offers.register') }}
        </button>
        <button class="button has-background-primary has-text-light"
                @click="addChoiceToCart({candidate, offer, school})" v-else>
          {{ $t('shop.offers.register') }}
        </button>
      </div>
    </div>


    <div class="p-md" v-if="currentOffer.category.has_sessions && suggestions.length > 3">
      <hr>
      <p class="title has-text-weight-light">{{ $t('shop.offers.more_internship') }}</p>


      <div class="columns has-text-centered scrolling-wrapper">


        <div class="column is-one-third-desktop is-half-tablet is-full-mobile" v-for="offer in suggestions"
             v-if="offer.id !== currentOffer.id" :key="offer.id">
          <div class="card-image">

            <a class="has-text-white" @click="pushToOffer(offer)">
              <figure class="image is-3by2 m-b-none">
                <img :src="randomImage(offer)" alt="">
              </figure>
              <div class="is-overlay is-clipped">
                <h2 class="card-footer-item title is-5 is-italic has-text-white  is-primary-opacity">
                  {{ offer.name.fr }}
                </h2>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="has-text-right p-md">
        <button class="button" @click="scroll_left()"><i class="fa fa-arrow-left"></i></button>
        <button class="button" @click="scroll_right()"><i class="fa fa-arrow-right"></i></button>
      </div>
    </div>

  </section>
</template>

<script>
import api from 'services/offers'
import {mapActions, mapGetters} from 'vuex'
import OfferFilters from './search/OfferFilters'

export default {
  data() {
    return {
      filtersView: OfferFilters,
      offer: null,
      category: null,
      sessions: [],
      suggestions: [],
      selectedSession: null,
      sessionStatuses: [
        {name: 'Complet', code: 'complete'},
        {name: 'Non disponible', code: 'unavailable'}
      ],
    }
  },
  props: {
    candidates: {type: Array},
    offerId: {type: Number},
    categoryId: {type: Number}
  },
  computed: {
    ...mapGetters(
        'sessions', [
          'offerSessions',
          'offerFilters',
          'isFilteredOfferSessions',
          'offerPagination'
        ]
    ),
    ...mapGetters('orders', [
      'isSelectedChoice',
      'isSelectedCandidate',
      'isSelectedGuestSessionChoice',
      'candidateSchooling',
      'selectedChoice',
      'candidateSchoolingInOrder',
      'candidateOfferChoices',
    ]),
    ...mapGetters('organization', [
      'getSchoolBySlug'
    ]),
    ...mapGetters(
        'auth', [
          'isLoggedIn'
        ]
    ),
    ...mapGetters('candidate', [
      'hasCandidates',
    ]),
    currentOffer() {
      return this.offer ? this.offer : null
    },
    categoryOffers() {
      return this.category ? this.category.offers : []
    },
    school() {
      return this.getSchoolBySlug(this.$route.params.school)
    },

  },
  methods: {
    ...mapActions('orders', [
      'addChoiceToCart',
      'addSessionChoiceToCart',
      'addChoiceToGuestCart',
      'removeChoiceFromCart'
    ]),
    ...mapActions('sessions', [
      'fetchOfferSessions',
      'filteredSessions'
    ]),
    cantRegister(candidate, session) {
      return this.isSelectedCandidate({
        candidate,
        session: session.id
      }) !== null || (session.remaining_places !== null && session.remaining_places <= 0) || session.status !== null
    },
    cantGuestRegister(offer, session) {
      return this.isSelectedGuestSessionChoice({
        candidate: null,
        offer,
        session
      }) || (session.remaining_places !== null && session.remaining_places <= 0) || session.status !== null
    },
    acceptedCandidate(candidate) {
      return candidate.applications.accepted && candidate.applications.accepted
    },
    pushToOffer(offer) {
      this.offerId = offer.id
      this.categoryId = offer.categoryId
      this.fetchOffer()
      this.fetchOfferCategory()
      this.filterSessions()
      if (this.$route.matched[0].meta.schoolType === 'highschool') {
        this.$router.push({name: 'highschool-offer', params: {categoryId: offer.categoryId, offerId: offer.id}})
      }
      if (this.$route.matched[0].meta.schoolType === 'eschool') {
        this.$router.push({name: 'eshop-offer', params: {categoryId: offer.categoryId, offerId: offer.id}})
      }

    },
    fetchOffer() {
      api.showOffer(this.offerId).then((result) => {
        this.offer = result.data
      }).catch(e => {
      })
    },
    fetchOfferCategory() {
      api.offerCategory(this.categoryId).then((result) => {
        this.category = result.data
      }).catch(e => {
      })
    },
    fetchOfferSuggests(categoryId) {
      let schooling = this.candidateSchoolingInOrder(this.candidates, 'pending')
      let offer = this.candidateOfferChoices('pending')

      let campus = null

      if (offer.length) {
        campus = offer[0].choices[0].session.campus_id
      }

      if (schooling) {
        campus = schooling.applications.choices[0].campus_id
      }

      api.offerSuggests(categoryId, campus).then((result) => {
        this.suggestions = result.data
      }).catch(e => {
      })
    },
    filterSessions() {

      if (this.offerFilters !== null) {
        //this.isLoading = true
        this.offerFilters.category = this.categoryId
        this.offerFilters.offer = this.offerId
        this.offerFilters.school = this.$route.params.school
        this.fetchOfferSessions({
          perPage: 200,
          filters: this.offerFilters
        }).then((result) => {
          if (this.$route.query.session) {
            this.selectedSession = this.offerSessions.find(session => session.id === parseInt(this.$route.query.session));
          }
        })

      } else {

        api.offerSessions(this.offerId, this.$route.params.school).then((result) => {


          this.sessions = result.data
          if (this.$route.query.session) {
            this.selectedSession = this.sessions.find(session => session.id === parseInt(this.$route.query.session));
          }
        }).catch(e => {
        })
      }


    },
    randomImage(offer) {
      if (offer.medias.length) {
        let image = offer.medias[Math.floor(Math.random() * offer.medias.length)];
        return '/img/offers/' + image.path
      }
    },
    offerFees(prices) {
      const school = this.getSchoolBySlug(this.$route.params.school)
      let schools = []
      if (school.type_id === 1) {
        schools = [school.id, 7]
      } else {
        schools = [school.id]
      }
      let offerPrices = _.orderBy(prices, 'year', 'desc')
      return offerPrices.filter(function (price) {
        return schools.includes(price.school_id)
      }).map(price => price.price + ' ' + price.currency)[0];
    },

    externshipFees(prices) {
      const school = this.getSchoolBySlug(this.$route.params.school)
      let schools = []
      if (school.type_id === 1) {
        schools = [school.id, 7]
      } else {
        schools = [school.id]
      }
      let offerPrices = _.orderBy(prices, 'year', 'desc')
      return offerPrices.filter(function (price) {
        return schools.includes(price.school_id)
      }).map(price => price.externship_price)[0];
    },

    offerExternshipFees(prices) {
      const school = this.getSchoolBySlug(this.$route.params.school)
      let schools = []
      if (school.type_id === 1) {
        schools = [school.id, 7]
      } else {
        schools = [school.id]
      }
      let offerPrices = _.orderBy(prices, 'year', 'desc')
      return offerPrices.filter(function (price) {
        return schools.includes(price.school_id)
      }).map(price => price.externship_price + ' ' + price.currency)[0];
    },
    displayStatus(status) {
      const sessionStatus = this.sessionStatuses.filter(function (sessionStatus) {
        return sessionStatus.code === status
      })[0]

      return sessionStatus.name
    },
    sessionFees(prices) {
      const school = this.getSchoolBySlug(this.$route.params.school)
      let schools = []
      if (school.type_id === 1) {
        schools = [school.id, 7]
      } else {
        schools = [school.id]
      }
      let offerPrices = _.orderBy(prices, 'year', 'desc')
      return offerPrices.filter(function (price) {
        return schools.includes(price.school_id)
      }).map(price => price.price);
    },
    sessionExternshipFees(prices) {
      const school = this.getSchoolBySlug(this.$route.params.school)
      let schools = []
      if (school.type_id === 1) {
        schools = [school.id, 7]
      } else {
        schools = [school.id]
      }
      let offerPrices = _.orderBy(prices, 'year', 'desc')
      return offerPrices.filter(function (price) {
        return schools.includes(price.school_id)
      }).map(price => price.externship_price);
    },
    guestChoice(choice) {

      if (choice.session.prices.length) {
        if (choice.type === 'externat') {
          choice.offer.price = parseInt(this.sessionExternshipFees(choice.session.prices))
        } else {
          choice.offer.price = parseInt(this.sessionFees(choice.session.prices))
        }

      } else {
        if (choice.type === 'externat') {
          choice.offer.price = parseInt(this.sessionExternshipFees(choice.offer.prices))
        } else {
          choice.offer.price = parseInt(this.sessionFees(choice.offer.prices))
        }

      }
      this.addChoiceToGuestCart(choice)
    },
    scroll_left() {
      let content = document.querySelector(".scrolling-wrapper");
      content.scrollLeft -= content.offsetWidth;
    },
    scroll_right() {
      let content = document.querySelector(".scrolling-wrapper");
      content.scrollLeft += content.offsetWidth;
    }

  },
  filters: {
    moment: function (date) {
      return moment(date).format('LL')
    }
  },
  created() {
    this.fetchOffer()
    this.fetchOfferCategory()
    this.fetchOfferSuggests(this.categoryId)
    this.filterSessions()
    if (this.$route.hash === '#session') {

      setTimeout(() => {
        this.$scrollTo('.sessions', {offset: -30}, 500)
      }, 300)
    }

  }
}
</script>

<style lang="scss" scoped>
img {
  object-fit: cover;
}

.button[disabled] {
  background-color: white;
  border-color: #dbdbdb;
  -webkit-box-shadow: none;
  box-shadow: none;
  opacity: 1;
}

.scrolling-wrapper {
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;

  .card-footer-item {
    white-space: normal;
    justify-content: left;
    text-align: left;
  }

  .column {
    display: inline-block;
  }
}

.scrolling-wrapper {
  &::-webkit-scrollbar {
    display: none;
  }
}

.session-image {
  padding-top: 25%;
  box-shadow: 0 1px 3px rgb(15, 30, 68), 0 0 0 0px rgba(10, 10, 10, 0.1);
}

.selected-session {
  margin-bottom: 1.75rem;
  background-color: white;
  border-radius: 2px;
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
}

.offer-session {
  margin-bottom: 1.75rem;
  background-color: white;
  border-radius: 2px;
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
}

.session-price hr {
  background-color: #0f1e44;
  height: 1px;
  margin: 0.5rem 3rem;
}

.border-left {
  border-left: 1px solid #0f1e44;
}

.stamp {
  transform: rotate(12deg);
  color: #555;
  font-size: 3rem;
  font-weight: 700;
  border: 0.25rem solid #555;
  display: inline-block;
  padding: 0.25rem 1rem;
  text-transform: uppercase;
  border-radius: 1rem;
  font-family: 'Courier';
  -webkit-mask-image: url('/img/icons/grunge.png');
  -webkit-mask-size: 944px 604px;
  mix-blend-mode: multiply;
}

.is-nope {
  color: #D23;
  border: 0.5rem double #D23;
  transform: rotate(3deg);
  -webkit-mask-position: 2rem 3rem;
  font-size: 1.5rem;
}

.is-draft {
  color: #C4C4C4;
  border: 1rem double #C4C4C4;
  transform: rotate(0deg);
  font-size: 0.9rem;
  font-family: "Open sans", Helvetica, Arial, sans-serif;
  border-radius: 0;
  padding: 0.5rem;
}

</style>
